// src/utils/transformInvoiceData.js
import { euroFormat } from "./usefullFunctions";
import moment from "moment";

export const transformInvoiceData = (item) => ({
    Projectcode: item.project.project_code,
    Projectnaam: item.project.project_name,
    ProjectcodeA: (
        <a href={`/project/${item.project.project_id}`}>
            {item.project.project_code}
        </a>
    ),
    ProjectnaamA: (
        <a href={`/project/${item.project.project_id}`}>
            {item.project.project_name}
        </a>
    ),
    Omschrijving: item.invoice.projects_invoice_terms_commentary,
    Bedrag: euroFormat(item.invoice.projects_invoice_terms_invoice_amount),
    Projectleider: item.project?.projects_employees_employee_name || "N/A",
    Datumverloop: moment(item.invoice.projects_invoice_terms_planned_for).format("DD MMMM YYYY"),
    status: item.invoice.projects_invoice_terms_status || 1,
    // Add original fields in the required structure
    original: item,
});
